import api from "@/assets/js/utils/api.js";
import {
  showSuccess,
  showError,
  showLoading,
  hideLoading,
} from "@/assets/js/utils/alertService";
import Swal from "sweetalert2";

export default {
  name: "CheckoutPage",
  data() {
    return {
      cartItems: [],
      totalAmount: 0,
      shippingFee: 100,

      // ✅ 用戶資料
      userProfile: {
        fullName: "",
        email: "",
        phoneNumber: "",
        address: "",
      },

      // ✅ 地址選擇類型
      addressType: "original", // 'original' 或 'new'

      orderForm: {
        customerName: "",
        phone: "",
        email: "",
        address: "",
        note: "", // 添加備註欄位
        paymentMethod: "貨到付款", // 當前預設支付方式
      },

      // ⚠️ 預留：未來支付方式（暫時關閉）
      // 支付方式: "貨到付款" | "超商繳費" | "ATM轉帳" | "信用卡"
      // availablePaymentMethods: [
      //   { value: "貨到付款", label: "貨到付款" },
      //   { value: "超商繳費", label: "超商繳費 (7-11/全家/萊爾富/OK超商)" },
      //   { value: "ATM轉帳", label: "ATM轉帳" },
      //   { value: "信用卡", label: "信用卡 (Visa/Mastercard)" },
      // ],
    };
  },

  computed: {
    finalAmount() {
      return this.totalAmount; // ❗只顯示後端計算好的總金額
    },
  },

  async mounted() {
    await this.loadUserProfile();
    await this.loadCartData();
  },

  methods: {
    // ✅ 載入用戶資料
    async loadUserProfile() {
      try {
        showLoading("載入用戶資料...");

        const res = await api.get("/front/customer/profile");

        if (res.data.success) {
          const data = res.data.data;
          this.userProfile = {
            fullName: data.FullName || "",
            email: data.Email || "",
            phoneNumber: data.PhoneNumber || "",
            address: data.Address || "",
          };

          // ✅ 自動填入表單
          this.orderForm.customerName = this.userProfile.fullName;
          this.orderForm.phone = this.userProfile.phoneNumber;
          this.orderForm.email = this.userProfile.email;

          // ✅ 如果有原本地址，預設使用原本地址
          if (this.userProfile.address) {
            this.addressType = "original";
            this.orderForm.address = this.userProfile.address;
          } else {
            // 沒有原本地址，強制使用新地址
            this.addressType = "new";
            this.orderForm.address = "";
          }

          console.log("載入的用戶資料:", this.userProfile);
        } else {
          showError(res.data.message || "載入用戶資料失敗");
        }
      } catch (error) {
        console.error("載入用戶資料失敗:", error);

        if (error.response?.status === 401) {
          showError("登入已失效，請重新登入");
          this.$router.push("/login");
        } else {
          showError("載入用戶資料失敗，請稍後再試");
        }
      } finally {
        hideLoading();
      }
    },

    // ✅ 選擇原本地址
    selectOriginalAddress() {
      this.orderForm.address = this.userProfile.address;
    },

    // ✅ 選擇新地址
    selectNewAddress() {
      this.orderForm.address = "";
    },

    async loadCartData() {
      try {
        const res = await api.get("/front/cart"); // 取得購物車資料

        if (!res.data?.success) {
          showError("無法取得購物車資料");
          return;
        }

        const cart = res.data.data; // 後端回傳的購物車資料

        // 🔹 設定購物車商品 (保持與 CartPage 相同格式)
        this.cartItems = (cart.Details || []).map((item) => ({
          id: item.Id,
          productId: item.ProductId,
          name: item.VariantName
            ? `${item.ProductName}（${item.VariantName}）` // 控制商品名稱+規格
            : item.ProductName,
          price: item.UnitPrice,
          quantity: item.Quantity,
          subtotal: item.Subtotal,
          image: item.PictureURL || require("@/assets/image/AYH.webp"),
        }));

        // 🔹 最終金額（⚠ 已含運費 / 折扣 / 優惠券）
        this.totalAmount = cart.FinalAmount;

        console.log("結帳頁載入 FinalAmount:", this.totalAmount);
      } catch (error) {
        console.error("載入購物車錯誤:", error);
        showError("無法載入購物車資料");
      }
    },
    formatPrice(price) {
      if (!price || isNaN(price)) return "0"; // 防止 undefined 報錯
      return Number(price).toLocaleString("zh-TW"); // 回傳千分位
    },

    // ⚠️ 預留：驗證超商繳費（未來使用）
    // validateConveniencePayment() {
    //   // TODO: 驗證超商繳費相關資訊
    //   // - 確認超商選擇
    //   // - 驗證配送地址是否支援該超商
    //   // - 生成超商繳費單號
    // }

    // ⚠️ 預留：驗證ATM轉帳（未來使用）
    // validateATMTransfer() {
    //   // TODO: 驗證ATM轉帳相關資訊
    //   // - 確認銀行代碼
    //   // - 確認帳號末五碼
    //   // - 產生ATM轉帳帳號與截止時間
    // }

    // ⚠️ 預留：驗證信用卡支付（未來使用）
    // validateCreditCardPayment() {
    //   // TODO: 驗證信用卡相關資訊
    //   // - 確認持卡人姓名
    //   // - 確認卡號（需加密傳輸）
    //   // - 確認有效期限與CVV
    //   // - 整合第三方支付服務 (ECPay, NewebPay, Stripe 等)
    // }

    async submitOrder() {
      if (!this.orderForm.customerName) {
        showError("請輸入姓名");
        return;
      }
      if (!this.orderForm.phone) {
        showError("請輸入電話");
        return;
      }
      if (!this.orderForm.address) {
        showError("請選擇或填寫收件地址");
        return;
      }

      // ✅ 付款方式提示確認
      const confirmResult = await Swal.fire({
        title: "付款方式確認",
        text: "目前付款方式僅支援「貨到付款」，是否確認送出訂單？",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "確認送出",
        cancelButtonText: "取消",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#6c757d",
        reverseButtons: true,
      });

      // ❌ 使用者取消
      if (!confirmResult.isConfirmed) {
        return;
      }

      try {
        // ✅ 固定貨到付款
        const paymentMethod = "貨到付款";

        // ⚠️ 預留：根據支付方式執行不同驗證（未來使用）
        // switch (paymentMethod) {
        //   case "超商繳費":
        //     this.validateConveniencePayment();
        //     break;
        //   case "ATM轉帳":
        //     this.validateATMTransfer();
        //     break;
        //   case "信用卡":
        //     await this.validateCreditCardPayment();
        //     break;
        //   default:
        //     // 貨到付款：無需額外驗證
        //     break;
        // }

        const payload = {
          cartId: this.cartData?.Id ?? 0,
          note: this.orderForm.note || "",
          paymentMethod,
          address: this.orderForm.address,
          // ⚠️ 預留：支付方式相關欄位（未來使用）
          // convenienceStore: null,  // 超商繳費：選擇的超商 (7-11/全家/萊爾富/OK)
          // atmBankCode: null,       // ATM轉帳：銀行代碼
          // atmAccountLast5: null,   // ATM轉帳：帳號末五碼
          // creditCardData: null,    // 信用卡：卡片資訊（需加密）
        };

        console.log("⚡ 送出的訂單資料：", payload);

        const res = await api.post("/front/order/create", payload);

        if (res.data?.success) {
          showSuccess("訂單建立成功 🎉");
          
          // ⚠️ 預留：根據支付方式導向不同的結果頁面（未來使用）
          // switch (paymentMethod) {
          //   case "超商繳費":
          //     this.$router.push(`/payment/convenience-store/${res.data.orderNo}`);
          //     break;
          //   case "ATM轉帳":
          //     this.$router.push(`/payment/atm-transfer/${res.data.orderNo}`);
          //     break;
          //   case "信用卡":
          //     this.$router.push(`/payment/credit-card/${res.data.orderNo}`);
          //     break;
          //   default:
          //     this.$router.push(`/order-success/${res.data.orderNo}`);
          // }
          
          this.$router.push(`/order-success/${res.data.orderNo}`);
        } else {
          showError(res.data.message ?? "訂單建立失敗");
        }
      } catch (err) {
        console.error("❌ 建立訂單錯誤：", err);
        showError("建立訂單失敗，請稍後再試");
      }
    },
    backToCart() {
      this.$router.push("/cart");
    },
  },
};
